///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-distributors.collection.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class DistributorDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected distributors: DistributorsCollection;

        public allSelectedLabel: string;
        public totalSelectedMessage: string;
        public title: string;

        get collection(): SmartMoverCollectionBase<any> {
            return this.distributors;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.title = 'LABEL_DISTRIBUTOR';
            this.allSelectedLabel = 'LABEL_ALL_DISTRIBUTORS';
            this.totalSelectedMessage = 'LABEL_TOTAL_DISTRIBUTORS_SELECTED';

            this.filters = [new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_DISTRIBUTORS'})];

            this.distributors = new DistributorsCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                defaultValue: (options.defaultValue || {})[properties[1]],
                url: options.url
            });
            this.distributors.addFilters(...this.filters as IInteractiveFilter[])
        }
    }
}
